import React from 'react'
import parse from 'html-react-parser'
import SearchForm from './search-form'
import PropertyCard from './cards/property'
import { Fade } from 'react-reveal'

import useForSaleQuery from "../hooks/use-for-sale-query"
import useAgentsQuery from "../hooks/use-agents-query"
import useSoldQuery from "../hooks/use-sold-query"
import useLeaseQuery from "../hooks/use-lease-query"
import useOffMarketQuery from "../hooks/use-off-market-query"

import useForSaleCommercialQuery from '../hooks/use-for-sale-commercial-query'
import useLeaseCommercialQuery from '../hooks/use-lease-commercial-query'
import useSoldCommercialQuery from '../hooks/use-sold-commercial-query'

const PropertyArchive = ({ title, type }) => {

  const staff = useAgentsQuery()

  const properties = {
    'for_sale': useForSaleQuery(),
    'sold': useSoldQuery(),
    'lease': useLeaseQuery(),
    'off_market': useOffMarketQuery(),
    'commercial_for_sale': useForSaleCommercialQuery(),
    'commercial_sold': useSoldCommercialQuery(),
    'commercial_lease': useLeaseCommercialQuery(),
  }[type]

  // State
  const [list, setList] = React.useState(properties);
  const [limit, setLimit] = React.useState(10);

  let suburbs = []
  let types = []

  properties?.forEach((el) => {
    let suburb = el.propertyAddress.suburb.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    suburbs.push(suburb);
    types.push(el.propertyData.category);
    if (el.propertyListing.offMarketListing) {
      types.push('Off Market');
    }
  });

  suburbs = suburbs.filter((v, i, a) => a.indexOf(v) === i);
  types = types.filter((v, i, a) => a.indexOf(v) === i)
  suburbs.sort()

  types.sort((a, b) => {
    if (a === 'Off Market') {
      return -1
    }
    if (b === 'Off Market') {
      return 1
    }
    return 0
  })

  // Ref
  const load = React.createRef();

  // Events
  let timeout = null
  const onScroll = () => {
    let position = load?.current?.getBoundingClientRect()
    if (!position) return
    if (position.top >= 0 && position.bottom <= window.innerHeight) {
      if (!timeout) {
        //if (!this.timeout && this.state.length < this.state.list) {
        timeout = setTimeout(() => {
          setLimit(limit + 6)
          timeout = null
        }, 10)
      }
    } else {
      clearTimeout(timeout)
    }
  }

  // Update
  React.useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  return (
    <section className='listings'>
      <div className='listings__inner'>
        {title && (
          <Fade bottom distance='40px'>
            <h1>{parse(title)}</h1>
          </Fade>
        )}
        <SearchForm
          list={properties || []}
          set={setList}
          type={type}
          staff={staff.allWpTeam.nodes}
          suburbs={suburbs}
          types={types}
        />
      </div>
      <div className='listings__items'>
        {list?.slice(0, limit).map((el) => {
          return (<PropertyCard key={el.id} {...el} postType={(type === 'lease' || type === 'commercial_lease') ? 'rental' : 'property'} />)
        })}
      </div>
      {list?.length === 0 && <p className='listings__no-results'>No listings at this time.</p>}
      <div ref={load} />
    </section>
  );
}

export default PropertyArchive